<div class="chat-container mat-badge-cuartenario"
     [ngClass]="{'chat-minimizado': minimize}"
     matBadgeSize="large"
     [matBadge]="chatInst.notificacionAgente"
     [matBadgeHidden]="chatInst.notificacionAgente == 0"
>
  <!-- Header del chat -->
  <header class="chat-header">
    <div class="chat-header-title" title="{{chatInst.negocio?.nombre}}" (click)="minimizeView()">
      <abbr class="header-title">
        {{ chatInst.negocio?.id }} -  {{ chatInst.negocio?.nombre }}
      </abbr>

    </div>

    <div
      class="header-subtitle-flotante texto-secundario hover-linnegocios"
      (click)="onScroll()"
      *ngIf="messages.length && !viewingPending && !isEndMessage && chatInst.typeChat === 'BranchAgent' && !minimize"
    >
      Ver mensajes anteriores
    </div>
    <div class="chat-header-actions">
      <button mat-icon-button matTooltip="Ver más opciones" [matMenuTriggerFor]="menuMore">
        <mat-icon>more_vert</mat-icon>

        <mat-menu #menuMore="matMenu">
          <button mat-menu-item (click)="closeChat()">
            <mat-icon>indeterminate_check_box</mat-icon>
            <span>Finalizar chat</span>
          </button>
        </mat-menu>
      </button>

      <button (click)="closeViewChat()" mat-icon-button matTooltip="Cerrar ventana chat">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <!-- Contenido del chat -->
  <main class="chat-content" [hidden]="minimize" #scrollframe (scroll)="onScroll()">
    <p class="texto-secundario" *ngIf="viewingPending">Mensajes pendientes de lectura, ordenados por fecha.</p>
    <p class="texto-secundario" *ngIf="viewingPending && !pendingMessages.length">No quedan pendientes por mostrar. Vuelve a los mensajes recientes.</p>
    <div class="chat-group" *ngFor="let group of groupedMessages; trackBy: trackGroup">
      <div class="chat-group-date">
        {{ group.date | dateFormatES }}
      </div>

      <div class="chat-message"
           *ngFor="let message of group.messages; trackBy: trackMessage"
           [ngClass]="{
           'no-accion-eliminar': !message.messageAgent,
            'chat-message-left': !message.messageAgent,
             'chat-message-right': message.messageAgent,
              'chat-message-close': message.messageEstatus === 'CLOSE'
              }"
           [attr.data-message-id]="message.idChatMessage" #items>

        <button
          mat-icon-button
          *ngIf="canOperate && message.sender?.id === chatInst.agente?.id && message.messageAgent && message.messageEstatus != 'ELIMINADO'"
          (click)="deleteMessages(message.idChatMessage)"
          class="delete-button"
        >
          <mat-icon>delete</mat-icon>
        </button>
        <div class="chat-message-header"
          *ngIf="message.messageEstatus !== 'CLOSE' && message.messageEstatus != 'ELIMINADO'">
          <div>{{ message.sender?.nombre }}</div>
          <div>{{ getTime(message.dateCreated) }}</div>
        </div>
        <div class="chat-message-body" [ngClass]="{'message-delete': message.messageEstatus === 'ELIMINADO'}">
          <mat-icon *ngIf="message.messageEstatus === 'ELIMINADO'" class="mr-1">
            block
          </mat-icon>
          <p
            class="message"
            [innerHTML]="message.message | linkify">
          </p>
          <app-filemessage
            *ngIf="message.archivo && message.messageEstatus != 'ELIMINADO'"
            class="message-file"
            [file]="{
                    fileName: message.archivo.nombre,
                    contentType: message.archivo.contentType,
                    url: message.archivo.url
                  }"
            [envia]="message.messageAgent"></app-filemessage>
        </div>
      </div>
    </div>

  </main>

  <!-- Footer del chat -->
  <footer class="chat-footer" [hidden]="minimize" #chatFooter>
    <div class="pending-status" *ngIf="chatInst.notificacionAgente > 0 || viewingPending">
      <span *ngIf="chatInst.notificacionAgente > 0">{{ chatInst.notificacionAgente }} pendientes de lectura. Pueden ser de fechas anteriores.</span>
      <div class="pending-actions">
      <button mat-button *ngIf="chatInst.notificacionAgente > 0" [disabled]="loadingPending" (click)="showPendingMessages()">{{ loadingPending ? 'Cargando pendientes' : 'Ver pendientes' }}</button>
      <button mat-button *ngIf="viewingPending" [disabled]="loadingPending" (click)="showRecentMessages()">Volver a recientes</button>
      </div>
      <span class="pending-note" *ngIf="!canOperate && chatInst.notificacionAgente > 0">En modo lectura no se confirman como leídos.</span>
    </div>
    <div role="status" style="grid-column:1/-1" class="texto-secundario">{{ (connection$ | async) === 'live' ? 'Conectado' : 'Conexión interrumpida' }} <button mat-button (click)="reconnect()">Reconectar</button></div>
    <div role="alert" style="grid-column:1/-1" *ngIf="errorMessage">{{ errorMessage }}</div>
    @if (canOperate) {

      <div *ngIf="file" [ngClass]="{ thumbnail_container: true, hide: !file }">
        <img alt="" [src]="whichFile()" class="thumbnail-image" (click)="openImages(whichFile())"/>
        <span class="acortarText" (click)="openImages(whichFile())">{{ file!.fileName }}</span>
        <button mat-icon-button [disabled]="isSendingMessage" (click)="cancelFile()">
          <mat-icon class="cursor-pointer">cancel</mat-icon>
        </button>
      </div>
      <button mat-icon-button matTooltip="Subir archivo" (click)="fileUpload.click()">
        <mat-icon>image</mat-icon>
      </button>
      <input
        [disabled]="isUploading || isSendingMessage || !chat.readMessages || robado"
        type="file"
        class="file-input"
        (change)="saveFile($event)"
        #fileUpload
        name="fileInput"
        accept="image/jpg,image/jpeg,image/png,video/mp4,image/jfif,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
      <mat-form-field appearance="outline" class="textarea-chat p-0">
       <textarea
         matInput
         class="limited-height"
         #messageInput
         [(ngModel)]="message"
         name="messageInput"
         (input)="adjustTextareaHeight($event)"
         (keydown)="onMessageKeydown($event)"
         [disabled]="isSendingMessage || !canOperate"
         rows="1"
         placeholder="Escribe aquí."
       ></textarea>
      </mat-form-field>
      <button mat-icon-button [disabled]="isSendingMessage || isUploading || !canOperate" matTooltip="Enviar mensaje" (click)="send()">
        <mat-icon>send</mat-icon>
      </button>
    } @else {
      <div></div>
      <div class="texto-secundario" *ngIf="!chatInst.readMessages">
        <mat-icon>
          visibility
        </mat-icon>
        Chat en modo lectura
      </div>
      <div></div>
    }

  </footer>
</div>
